// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileFeed-cls1_QMz","cls2":"ProfileFeed-cls2_CKh ProfileFeed-cls1_QMz"};